function TeamPage() {
  return <h1>Team</h1>;
}

export default TeamPage;
